import { DateTime } from 'luxon';

import type {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';

interface TripDetailsSuggestedPickupTimeProps {
  tripData?: TripRead;
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead;
}

export function TripDetailsSuggestedPickupTime({
  tripData,
  trip,
}: TripDetailsSuggestedPickupTimeProps) {
  const suggestedPickupTime =
    tripData === undefined
      ? 'suggested_pickup_time' in trip
        ? trip.suggested_pickup_time
        : null
      : tripData.suggested_pickup_time;

  if (!suggestedPickupTime) return null;

  const suggestedPickupTimeFormatted = DateTime.fromISO(
    suggestedPickupTime
  ).toLocaleString(DateTime.DATETIME_MED);

  return (
    <div className="flex flex-col gap-1 py-2">
      <h4 className="text-sm font-bold">Suggested Pickup Time</h4>
      <p className="text-sm font-medium text-gray-500">
        {suggestedPickupTimeFormatted}
      </p>
    </div>
  );
}
